export default __webpack_public_path__ + "static/media/vyhled-z-terasy.8fb1da45.jpeg";